import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Breadcrumb, RemoveDialogService } from 'src/app/shared/components';
import { catchErr, formatHumanTime } from 'src/app/shared/utils';
import { Dio, MonitoramentoGeolocalizacao, StatusAfericaoDIO, StatusExecucaoDIO } from '../dio.model';
import { DioService } from '../dio.service';
import { RegistrarApontamentoComponent } from './registrar-apontamento/registrar-apontamento.component';
import { Observable, Subject, catchError, concat, distinctUntilChanged, map, of, switchMap, tap } from 'rxjs';

import { groupBy, identity, mapValues, pickBy, uniqBy } from 'lodash-es';
import { AfericaoService } from '../afericao.service';
import { AuthService, RolesEnum } from 'src/app/core';
import { AprovarDto } from './aprovar.dto';
import { convertMinutesToHours, formatarTempoMinutosESegundos, getHorario, useTimeOneDate } from 'src/app/shared/date-utils';
import dayjs from 'dayjs';
import * as jsonMock from './response-mock'
import { MetricaService } from 'src/app/metrica/metrica.service';
import { UtcDatePipe } from 'src/app/shared/pipes/utc-date.pipe';
import { AssinaturaDioComponent } from '../view-dio/assinatura-dio/assinatura-dio.component';
import { SharedService } from 'src/app/shared/services/shared.service';
import { environment } from 'src/environments/environment';
import { consumerPollProducersForChange } from '@angular/core/weak_ref.d-DWHPG08n';

@Component({
    selector: 'app-aferir-dio',
    templateUrl: './aferir-dio.component.html',
    styleUrls: ['./aferir-dio.component.css'],
    providers: [DatePipe],
    standalone: false
})
export class AferirDioComponent implements OnInit {

    loading: any = { main: true, dios: false, afericao: false, aprovacao: false, mapa: false, info2Points: false };
    show: any = { actions: false, timeline: false, options: false, cancels: false, legend: false, info2Points: false };
    isModoAfericao: boolean = true;
    panelOpenState: boolean[] = [];
    titlePage: string = 'Aferir DIO';
    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Diários de Operação', route: '/dio' },
        { label: 'Aferir DIO' },
    ]

    hideBreadcrumb: boolean = false;

    dio = {} as Dio;
    afericao = {} as any;
    diosCompare: Dio[];
    dios$: Observable<Dio[]>;
    diosInput$ = new Subject<string>();
    particalCancels: any[];
    deletedCortes: string[] = [];
    currentRole: string;

    horasTrabalhadas: string;
    horasDisponiveis: string;
    kmRodados: number;

    dataInicioGPS: string | undefined;
    dataFimGPS: string | undefined;

    startTime: string;
    endTime: string;

    map: google.maps.Map;
    heatmap: any;
    dataPositions: MonitoramentoGeolocalizacao[] = [];
    dataPositionsFiltered: MonitoramentoGeolocalizacao[] = [];

    currentDirectionPaths: google.maps.LatLng[][] = [];
    lineDirections: google.maps.Polyline[] = [];

    points: any = {
        dio: false,
        stop: true,
        directions: true,
        info2Points: { start: null, end: null, data: null },
    };

    directionsService = new google.maps.DirectionsService();
    infoWindow = new google.maps.InfoWindow();
    infoWindowEvent: any = { open: null, close: null };

    svgFlag = {
        url: '../../../assets/img/flag_start.svg',
        scaledSize: new google.maps.Size(30, 30),
        anchor: new google.maps.Point(3, 30),
    }
    svgMarkerStopPath = 'M12,2C8.1,2,5,5.1,5,9c0,5.2,7,13,7,13s7-7.8,7-13C19,5.1,15.9,2,12,2z M12,4.6c0.9,0,1.6,0.3,2.3,0.7l-6.1,6.1 C7.8,10.6,7.6,9.9,7.6,9C7.6,6.6,9.6,4.6,12,4.6z M12,13.4c-0.9,0-1.6-0.3-2.3-0.7l6.1-6.1c0.4,0.7,0.7,1.5,0.7,2.3 C16.4,11.4,14.4,13.4,12,13.4z';
    svgMarkerDefaultPath = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z';
    svgMarker = {
        path: this.svgMarkerDefaultPath,
        fillColor: 'red',
        fillOpacity: 1,
        strokeWeight: 1,
        strokeOpacity: .3,
        rotation: 0,
        scale: 1,
        anchor: new google.maps.Point(12, 22),
    };

    constructor(
        private activatedRoute: ActivatedRoute,
        private afericaoService: AfericaoService,
        private authService: AuthService,
        private datePipe: DatePipe,
        private dialog: MatDialog,
        private dioService: DioService,
        private metricaService: MetricaService,
        private removeDialogService: RemoveDialogService,
        private snackBar: MatSnackBar,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private sharedService: SharedService,
    ) { }

    ngOnInit() {

        this.currentRole = this.authService.user.realm_access.roles[0];
        if (this.activatedRoute.snapshot.url[1].path === 'mapa') {
            this.isModoAfericao = false;
            this.titlePage = 'Visualizar Mapa';
        }

        this.dio.id = this.activatedRoute.snapshot.params['idDio'];
        this.breadcrumb = [
            { label: 'Início' },
            { label: 'Diários de Operação', route: '/dio' },
            { label: 'Visualizar DIO', route: `/dio/${this.dio.id}/visualizar` },
            { label: this.isModoAfericao ? 'Aferir DIO' : 'Mapa' },
        ];

        if (this.dio.id) {
            this.getDio();
            this.getAfericao(this.dio.id);
        }

        this.sharedService.currentValue.subscribe(value => {
            this.hideBreadcrumb = value;
        });
    }

    private checkStreetViewAvailability(): boolean {
        try {
            // Verifica se o Street View está disponível
            return !!(window as any).google && 
                   !!(window as any).google.maps && 
                   !!(window as any).google.maps.StreetViewPanorama;
        } catch (error) {
            console.warn('Street View não está disponível:', error);
            return false;
        }
    }

    /**
     * Valida se uma string de geolocalização está em formato válido (lat,lng)
     * @param geolocalizacao String no formato "latitude,longitude"
     * @returns true se válida, false caso contrário
     */
    private isValidGeolocation(geolocalizacao: string): boolean {
        if (!geolocalizacao || typeof geolocalizacao !== 'string' || geolocalizacao.trim() === '') {
            return false;
        }

        const coords = geolocalizacao.split(',');
        if (coords.length !== 2) {
            return false;
        }

        const lat = parseFloat(coords[0].trim());
        const lng = parseFloat(coords[1].trim());

        if (isNaN(lat) || isNaN(lng)) {
            return false;
        }

        // Verifica se as coordenadas estão em faixas válidas
        if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
            return false;
        }

        return true;
    }

    aprove() {
        this.loading.aprovacao = true;
        const aprovarDto: AprovarDto = {
            isCorteTotal: this.deletedCortes.length === 0 && this.particalCancels.length === 0,
            cortes: this.deletedCortes,
            motivo: `Aprovado por ${this.authService.user.firstName} ${this.authService.user.lastName}`,
        };

        this.afericaoService.aprovar(this.dio.id || '', aprovarDto).subscribe({
            next: (res) => {
                this.snackBar.open('Aferição aprovada com sucesso', '✓', { panelClass: 'success' });
                this.getAfericao(this.dio.id || '');
                this.getDio();
                this.dioService.notifygetMetricsSubject();
                this.loading.aprovacao = false;
            }, error: (err) => {
                catchErr(err, this.snackBar)
                this.loading.aprovacao = false;
            }
        });
    }

    finish() {
        this.loading.afericao = true;
        const hasRessalva = this.particalCancels && this.particalCancels.length > 0;

        this.afericaoService.finishAfericao(this.dio.id || '', {
            hasRessalva,
            isCorteTotal: false,
        }).subscribe({
            next: (res) => {
                this.snackBar.open('Aferição finalizada com sucesso', '✓', { panelClass: 'success' });
                //this.getAfericao(this.dio.id || '');
                //this.getDio();
                this.dioService.notifygetMetricsSubject();
                this.loading.afericao = false;

                this.router.navigate(['pendencias/afericao']);
            }, error: (err) => {
                this.loading.afericao = false;
                catchErr(err, this.snackBar);
            }
        });
    }

    canFinishAfericao() {
        const rolesAllowed = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.AFERIDOR.toString(),
            RolesEnum.COORDENADOR.toString(),
        ].includes(this.currentRole);

        const status = this.afericao && this.afericao.status === StatusAfericaoDIO.AGUARDANDO_AFERICAO;
        return rolesAllowed && status;
    }

    canAproveOrDeleteAfericao() {
        const rolesAllowed = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.COORDENADOR.toString(),
        ].includes(this.currentRole);

        const status = this.afericao && this.afericao.status === StatusAfericaoDIO.AGUARDANDO_APROVACAO_AFERICAO;
        return rolesAllowed && status;
    }

    canRegisterAppointment() {
        if(this.currentRole === RolesEnum.FUNCIONARIO){
            return this.dio.statusExecucao === StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO;
        }

        const podeRegistarApontamento = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.COORDENADOR.toString(),
            RolesEnum.FUNCIONARIO.toString(),
            RolesEnum.FISCAL.toString(),
            RolesEnum.AFERIDOR.toString(),            
        ];

        const statusSemRegistroApontamentos = ['AFERICAO_VALIDADA_SEM_RESSALVAS']

        return podeRegistarApontamento.includes(this.currentRole) && !statusSemRegistroApontamentos.includes(this.dio.statusAfericao);
    }

    canSeeActions() {
        return [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.COORDENADOR.toString(),
            RolesEnum.AFERIDOR.toString(),
            RolesEnum.FUNCIONARIO.toString(),
            RolesEnum.FISCAL.toString(),
        ].includes(this.currentRole);
    }

    showCancelDialog(cancelTotal?: boolean) {
        const aprovarCtx = this.dio.statusAfericao === StatusAfericaoDIO.AGUARDANDO_APROVACAO_AFERICAO;

        const dialogRef = this.dialog.open(RegistrarApontamentoComponent, { data: { aprovarCtx, cancelTotal, dio: this.dio }, width: '60vw' });
        dialogRef.afterClosed().subscribe(result => {            
            if(result === true){
                //this.getAfericao();
                this.getDio();
                this.getAfericao(this.dio.id || '');
            }
        });
    }

    showDiv(div: string) {
        this.show = mapValues(this.show, (value: any, key: any) => (div === key) ? !this.show[div] : (key === 'actions' ? value : false))
        this.show.actions = (this.show[div] && this.show.actions) ? true : !this.show.actions
    }

    showPoint(index: number) {
        
        // Validação do índice
        if (index < 0 || index >= this.dataPositions.length) {
            console.warn('Índice de ponto inválido:', index);
            return;
        }

        const point = this.dataPositions[index];
        if (!point || !point.geolocalizacao) {
            console.warn('Ponto ou geolocalização inválidos:', point);
            return;
        }

        try {
            this.map.setZoom(15);
            this.map.panTo(this.stringToLatLng(point.geolocalizacao));
            this.panelOpenState[index] = !this.panelOpenState[index];
        } catch (error) {
            console.error('Erro ao mostrar ponto:', error);
            const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
            this.snackBar.open(`Erro ao navegar para o ponto: ${errorMessage}`, '⚠️', { 
                panelClass: 'warning',
                duration: 3000 
            });
        }
    }

    toggleDioPoints($event: MatSlideToggleChange) {
        this.points.dio = $event.checked;
        this.points.stop = true;        

        if(this.dataPositions.length) {
            this.dataPositions.map((point) => { if (point.marker) point.marker.map = $event.checked ? this.map : null; })
        }
    }

    toggleStopPoint($event: MatSlideToggleChange | { checked: boolean }) {        
        // Filtrar pontos com geolocalização válida antes de agrupar
        const validDataPositions = this.dataPositions.filter(point => {
            if (!point.geolocalizacao || typeof point.geolocalizacao !== 'string') {
                console.warn('Ponto com geolocalização inválida ignorado:', point);
                return false;
            }
            return true;
        });

        const group = groupBy(validDataPositions, 'geolocalizacao');
        let stopPoints: any = pickBy(mapValues(group, (value) => value.length > 1 ? value : undefined), identity);

        if ($event.checked) {            
            stopPoints = mapValues(stopPoints, (points, index) => {
                let start: any, end: any;
                points?.map((point: any) => {
                    start = start || point.data_transmissao;
                    start = dayjs(start).valueOf() < dayjs(point.data_transmissao).valueOf() ? start : point.data_transmissao;
                    end = end || point.data_transmissao;
                    end = dayjs(end).valueOf() < dayjs(point.data_transmissao).valueOf() ? point.data_transmissao : end;

                    point.start = start;
                    point.end = end;
                    point.qtde = stopPoints[index].length;
                    point.period = dayjs(end).diff(dayjs(start), 'seconds');
                });
                return points.pop();
            });

            this.dataPositionsFiltered = Object.values(stopPoints);
            this.dataPositions.map((point, idx) => {
                if (!point.marker) return;
                const isEndpoint = idx === 0 || idx === this.dataPositions.length - 1;
                const isStopPoint = !!this.dataPositionsFiltered.find((p) => p.geolocalizacao === point.geolocalizacao);
                point.marker.map = isEndpoint || (this.points.dio && isStopPoint) ? this.map : null;
            });

        } else {
            this.dataPositionsFiltered = this.dataPositions;
            this.dataPositions.map((point, idx) => {
                if (!point.marker) return;
                const isEndpoint = idx === 0 || idx === this.dataPositions.length - 1;
                point.marker.map = isEndpoint ? this.map : null;
            });
        }

    }

    toggleHeatMap($event: MatSlideToggleChange) {        
        if (!this.heatmap) {
            this.snackBar.open('Mapa de calor não disponível nesta versão da API', '✕', { panelClass: 'warning', duration: 3000 });
            return;
        }
        $event.checked ? this.heatmap.setMap(this.map) : this.heatmap.setMap(null);
    }

    toggleDirections($event: { checked: boolean }, dataArray?: any[]) {        
        
        if (($event.checked && !this.currentDirectionPaths.length) || !!dataArray) {
            const data = dataArray || this.dataPositions;
            const uniq = uniqBy(data, 'geolocalizacao');
            const size = 20;
            let count = 0;
            let dataChunk = uniq.reduce((prev: any, curr, index, arr) => {
                if (index % size === 0) {
                    prev.push(arr.slice(index - count, index - count + size));
                    count++;
                }
                return prev;
            }, []);

            dataChunk.map((chunk: any) => {
                try {
                    const validChunk = chunk.filter((point: any) => {
                        if (!point.geolocalizacao || typeof point.geolocalizacao !== 'string') {
                            console.warn('Ponto inválido para direções:', point);
                            return false;
                        }
                        return true;
                    });

                    if (validChunk.length < 2) {
                        console.warn('Chunk insuficiente para criar direções:', validChunk.length);
                        return;
                    }

                    const waypoints = validChunk.slice(1, -1).map((point: any) => {
                        try {
                            return { location: this.stringToLatLng(point.geolocalizacao), stopover: false };
                        } catch (error) {
                            console.warn('Erro ao criar waypoint:', error);
                            return null;
                        }
                    }).filter((wp: any) => wp !== null);

                    const originLatLng = this.stringToLatLng(validChunk[0].geolocalizacao);
                    const destLatLng = this.stringToLatLng(validChunk[validChunk.length - 1].geolocalizacao);

                    this.directionsService.route({
                        origin: originLatLng,
                        destination: destLatLng,
                        waypoints,
                        travelMode: google.maps.TravelMode.DRIVING,
                    }, (result, status) => {
                        if (status === 'OK' && result) {
                            const path: google.maps.LatLng[] = result.routes[0].overview_path;
                            this.currentDirectionPaths.push(path);
                            this.drawLineDirections(path);
                        } else {
                            console.log('result: ', result);
                            console.log('status: ', status);

                            console.error('Erro nas direções:', status);                            
                        }
                    });
                } catch (error) {
                    console.error('Erro ao processar chunk de direções:', error);
                    const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
                    this.snackBar.open(`Erro ao criar direções: ${errorMessage}`, '⚠️', { 
                        panelClass: 'warning',
                        duration: 3000 
                    });
                }
            });
        } else if ($event.checked && this.currentDirectionPaths.length) {
            this.currentDirectionPaths.forEach((path) => this.drawLineDirections(path));
        } else {
            this.lineDirections.map((line) => line.setMap(null));
            this.lineDirections = [];
        }
    }

    private drawLineDirections(pathArray: google.maps.LatLng[]) {
        
        this.lineDirections.push(new google.maps.Polyline({
            map: this.map,
            path: pathArray,
            strokeColor: '#4285F4',
            strokeWeight: 5,
            strokeOpacity: .75,
            icons: [{
                icon: {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 5,
                    strokeColor: '#fff',
                    strokeWeight: 2,
                    strokeOpacity: 1,
                    fillColor: '#4285F4',
                    fillOpacity: 1
                },
                repeat: '100px',
            }]
        }));
    }

    private getHorasDisponiveis(dio: Dio): string {
        let minutosDisponiveis = 0;
        const execucao = dio.execucaoDetalhes;

        if (execucao && execucao.length) {
            minutosDisponiveis = execucao[0].disponibilidadeTotalMinutes ? execucao[0].disponibilidadeTotalMinutes : 0;
        }

        const { hours, minutes } = convertMinutesToHours(minutosDisponiveis);

        let message = `${hours} Horas e ${minutes} min`;

        if (hours === 0) {
            message = `${minutes} Minutos`;
        } else if (minutes === 0) {
            message = `${hours} Horas`;
        }

        return minutosDisponiveis != 0 ? message : '---';
    }

    private getHorasTrabalhadas(dio: Dio): string {
        let minutosTrabalhados = 0;
        const execucaoSistema = dio.execucaoDetalhes?.filter(e => e.tipo === 'SISTEMA');

        if (execucaoSistema && execucaoSistema.length) {
            minutosTrabalhados = execucaoSistema[0].funcionamentoTotalMinutes ? execucaoSistema[0].funcionamentoTotalMinutes : 0;
        } else {
            minutosTrabalhados = dio.execucaoDetalhes && dio.execucaoDetalhes.length && dio.execucaoDetalhes[0].funcionamentoTotalMinutes ? dio.execucaoDetalhes[0].funcionamentoTotalMinutes : 0;
        }

        const { hours, minutes } = convertMinutesToHours(minutosTrabalhados);

        let message = `${hours} Horas e ${minutes} min`;

        if (hours === 0) {
            message = `${minutes} Minutos`;
        } else if (minutes === 0) {
            message = `${hours} Horas`;
        }

        return minutosTrabalhados != 0 ? message : '---';
    }

    private getKmsRodados(dio: Dio): number {
        const execucaoSistema = dio.execucaoDetalhes?.filter(e => e.tipo === 'SISTEMA');

        if(execucaoSistema && execucaoSistema.length > 0){
            return execucaoSistema[0].kmRodados ? execucaoSistema[0].kmRodados : 0;
        }

        return dio.execucaoDetalhes && dio.execucaoDetalhes.length ? dio.execucaoDetalhes[0].kmRodados ? dio.execucaoDetalhes[0].kmRodados : 0 : 0;
    }

    // start

    private getAfericao(dioId: string) {
        this.afericaoService.findAfericaoByDio(dioId).subscribe({
            next: (res) => {
                this.afericao = res;
                if (this.afericao?.status !== 'PENDENTE_APROVACAO' && this.afericao?.status !== 'INICIADA') {
                    this.isModoAfericao = false;
                }

                // getParcialCancelations
                this.afericaoService.getApontamentos(dioId).subscribe({
                    next: (res) => {
                        this.particalCancels = res                        
                        
                        if(this.particalCancels){
                            this.particalCancels.forEach(p => {
                                let regrasStr = ''
                                if(p.regras && p.regras.length){
                                    p.regras.forEach((r: { regra: string; }) => {regrasStr = regrasStr + r.regra + ', '});
                                }
                                p.regrasStr = regrasStr;                                
                            })
                        }

                        this.cdr.detectChanges();
                    },
                    error: (err) => console.log(err)
                });
            }, error: (err) => catchErr(err, this.snackBar)
        });
    }

    private async getDio() {
        this.dioService.getById<Dio>(this.dio.id || '').subscribe({
            next: (res) => {
                this.dio = res;
                this.horasDisponiveis = this.getHorasDisponiveis(this.dio);
                this.horasTrabalhadas = this.getHorasTrabalhadas(this.dio);
                this.kmRodados = this.getKmsRodados(this.dio);

                this.startTime = getHorario(res.dataInicioExecucao);
                this.endTime = getHorario(res.dataFimExecucao);

                this.getDios();
                this.initMap();
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.main = false);
    }

    private getDios() {
        this.dios$ = concat(
            of([]), // default items
            this.diosInput$.pipe(
                distinctUntilChanged(),
                tap(() => this.loading.dios = true),
                switchMap((term) => {
                    return term ?
                        this.dioService.getPaginated<Dio>(0, 20, { numero: term }).pipe(
                            map((res) => res.data),
                            catchError(() => of([])), // empty list on error
                            tap(() => this.loading.dios = false)
                        ) : new Promise(() => this.loading.dios = false) // not search all
                })
            )
        ) as Observable<Dio[]>;
    }

    private async initMap() {
        
        try {
            
            // Verifica se Street View está disponível
            const streetViewAvailable = this.checkStreetViewAvailability();
            
            this.map = new google.maps.Map(
                document.getElementById('map') as HTMLElement,
                {
                    center: { lat: -15.8010569, lng: -47.9299997 },
                    zoom: 11,
                    mapId: environment.googleMapsMapId,
                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        style: (window as any).google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                        position: google.maps.ControlPosition.TOP_RIGHT,
                    },
                    fullscreenControl: false,
                    streetViewControl: streetViewAvailable,
                    streetViewControlOptions: streetViewAvailable ? {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    } : undefined,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    },
                    styles: [{
                        featureType: 'poi',
                        elementType: 'labels',
                        stylers: [{ visibility: 'off' }]
                    }],
                    // Configurações adicionais para evitar erros do Street View
                    gestureHandling: 'greedy',
                    restriction: {
                        latLngBounds: {
                            north: 5,
                            south: -35,
                            west: -75,
                            east: -30
                        },
                        strictBounds: false
                    }
                }
            );

            // Adiciona listener para erros do Street View
            if (this.map) {
                this.map.addListener('error', (error: any) => {
                    console.warn('Erro no Google Maps:', error);
                    this.snackBar.open('Erro no Street View. Verifique se a localização possui cobertura.', '⚠️', { 
                        panelClass: 'warning',
                        duration: 5000 
                    });
                });
            }

            this.getDataPositions();
        } catch (error) {
            console.error('Erro ao inicializar o mapa:', error);
            this.snackBar.open('Erro ao inicializar o mapa', '✕', { panelClass: 'danger' });
        }
    }

    getDataPositionsByTime() {
        if (this.startTime && this.endTime) {
            this.getDataPositions(`${this.startTime.slice(0, 2)}:${this.startTime.slice(2)}`, `${this.endTime.slice(0, 2)}:${this.endTime.slice(2)}`);
        } else if (!this.startTime && !this.endTime) {
            this.getDataPositions()
        }
    }

    private getDataPositions(startTime?: string, endTime?: string) {
        if (this.dio && this.dio.alocacao?.equipamento?.placa && this.dio.dataInicioExecucao && (this.dio.dataFimExecucao || this.currentRole === RolesEnum.GESTAO_ADMIN)) {
            if (this.dio.dataFimExecucao === undefined || this.dio.dataFimExecucao == null) {
                this.dio.dataFimExecucao = new Date();
            }

            this.loading.mapa = true;

            if (startTime && endTime) {
                this.dio.dataInicioExecucao = useTimeOneDate(this.dio.dataInicioExecucao, startTime);
                this.dio.dataFimExecucao = useTimeOneDate(this.dio.dataFimExecucao, endTime);
            }

            let periodoInicio = dayjs(this.dio.dataInicioExecucao).format('YYYY-MM-DD HH:mm:ss');
            let periodoFim = dayjs(this.dio.dataFimExecucao).format('YYYY-MM-DD HH:mm:ss');
            this.dioService.getGeolocalizacoesByEquipamentoId({
                idEquipamento: this.dio.alocacao.equipamento.id,
                start: periodoInicio,
                end: periodoFim
            }).subscribe({
                next: (res) => {

                    // TODO remover mock
                    if (this.dio.numero === '69') {
                        console.log("mock: ", jsonMock);
                        res = jsonMock.geosMock;
                    }

                    if (res && res.length > 0) {
                        // Validar e filtrar dados de geolocalização
                        const validPositions = res.filter((point, index) => {
                            if (!point) {
                                console.warn(`Ponto ${index} é null/undefined`);
                                return false;
                            }

                            if (!point.geolocalizacao || typeof point.geolocalizacao !== 'string') {
                                console.warn(`Ponto ${index} sem geolocalização válida:`, point);
                                return false;
                            }

                            // Validação básica do formato lat,lng
                            const coords = point.geolocalizacao.split(',');
                            if (coords.length !== 2) {
                                console.warn(`Ponto ${index} com formato de coordenada inválido:`, point.geolocalizacao);
                                return false;
                            }

                            const lat = parseFloat(coords[0].trim());
                            const lng = parseFloat(coords[1].trim());

                            if (isNaN(lat) || isNaN(lng)) {
                                console.warn(`Ponto ${index} com coordenadas não numéricas:`, { lat: coords[0], lng: coords[1] });
                                return false;
                            }

                            return true;
                        });

                        if (validPositions.length === 0) {
                            this.snackBar.open('Nenhum ponto com coordenadas válidas foi encontrado', '✕', { panelClass: 'warning' });
                            return;
                        }

                        if (validPositions.length < res.length) {
                            console.warn(`${res.length - validPositions.length} pontos com coordenadas inválidas foram ignorados`);
                            this.snackBar.open(`${res.length - validPositions.length} pontos inválidos foram ignorados`, '⚠️', { 
                                panelClass: 'warning',
                                duration: 3000 
                            });
                        }

                        this.dataPositions = validPositions;
                        this.dataPositionsFiltered = this.dataPositions;
                        
                        if ((window as any).google?.maps?.visualization?.HeatmapLayer) {
                            // Filtrar pontos válidos para o heatmap
                            const validHeatmapPoints = res.filter(point => {
                                if (!point.geolocalizacao || typeof point.geolocalizacao !== 'string') {
                                    console.warn('Ponto sem geolocalização válida para heatmap:', point);
                                    return false;
                                }
                                
                                const geo = point.geolocalizacao.split(',');
                                if (geo.length !== 2) {
                                    console.warn('Formato de geolocalização inválido para heatmap:', point.geolocalizacao);
                                    return false;
                                }

                                const lat = parseFloat(geo[0].trim());
                                const lng = parseFloat(geo[1].trim());

                                if (isNaN(lat) || isNaN(lng)) {
                                    console.warn('Coordenadas não numéricas para heatmap:', { lat: geo[0], lng: geo[1] });
                                    return false;
                                }

                                if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
                                    console.warn('Coordenadas fora da faixa válida para heatmap:', { lat, lng });
                                    return false;
                                }

                                return true;
                            }).map((point) => {
                                const geo = point.geolocalizacao.split(',');
                                return new (window as any).google.maps.LatLng(parseFloat(geo[0]), parseFloat(geo[1]));
                            });

                            if (validHeatmapPoints.length > 0) {
                                this.heatmap = new (window as any).google.maps.visualization.HeatmapLayer({
                                    radius: 20,
                                    data: validHeatmapPoints,
                                });
                                console.log(`Heatmap criado com ${validHeatmapPoints.length} pontos válidos de ${res.length} pontos totais`);
                            } else {
                                console.warn('Nenhum ponto válido encontrado para criar o heatmap');
                            }
                        }
                        
                        this.setDataPositionsMarkers();
                    } else {
                        this.snackBar.open('Nenhum ponto foi retornado para o veículo', '✕', { panelClass: 'warning' });
                    }
                },
                error: (err) => {
                    this.snackBar.open('Não foi possível buscar a rota do veículo', '✕', { panelClass: 'danger' })
                }
            }).add(() => this.loading.mapa = false);
        }
    }

    private setDataPositionsMarkers() {
        if (!this.map || !(window as any).google || !this.svgMarker || !this.svgFlag) return;

        const AdvancedMarkerElement = (window as any).google.maps.marker?.AdvancedMarkerElement;
        if (!AdvancedMarkerElement) {
            console.error('AdvancedMarkerElement não disponível. Verifique se a biblioteca "marker" está carregada.');
            return;
        }

        this.dataPositions && this.dataPositions.length > 0 && this.dataPositions.map((data, index) => {
            // Validação da geolocalização antes de criar o marker
            if (!data.geolocalizacao || typeof data.geolocalizacao !== 'string') {
                console.warn(`Ponto ${index} sem geolocalização válida:`, data);
                return; // Pula este ponto
            }

            try {
                // Tenta criar o marker com validação
                const position = this.stringToLatLng(data.geolocalizacao);
                const isEndpoint = index === 0 || index === this.dataPositions.length - 1;

                // Monta o conteúdo HTML do marker
                let content: HTMLElement;
                if (isEndpoint) {
                    const img = document.createElement('img');
                    img.src = index === 0 ? '../../../assets/img/flag_start.svg' : '../../../assets/img/flag_end.svg';
                    img.style.width = '40px';
                    img.style.height = '40px';
                    content = img;
                } else {
                    const fillColor = data.ignicao ? '#ADD8E6' : '#1E90FF';
                    const path = (!data.velocidade || data.velocidade <= 0) ? this.svgMarkerStopPath : this.svgMarkerDefaultPath;
                    const svgNS = 'http://www.w3.org/2000/svg';
                    const svgEl = document.createElementNS(svgNS, 'svg') as unknown as HTMLElement;
                    svgEl.setAttribute('viewBox', '0 0 24 24');
                    svgEl.setAttribute('width', '24');
                    svgEl.setAttribute('height', '24');
                    const pathEl = document.createElementNS(svgNS, 'path');
                    pathEl.setAttribute('d', path);
                    pathEl.setAttribute('fill', fillColor);
                    pathEl.setAttribute('stroke', 'rgba(0,0,0,0.3)');
                    pathEl.setAttribute('stroke-width', '1');
                    svgEl.appendChild(pathEl);
                    content = svgEl as unknown as HTMLElement;
                }

                const marker = new AdvancedMarkerElement({
                    map: null,
                    position: position,
                    content,
                    zIndex: isEndpoint ? 2 : 1,
                });

                marker.addListener('click', () => {
                    if (!this.infoWindow) return;

                    this.infoWindow.setContent(this.getInfoWindowContent(data));
                    this.infoWindow.open({
                        anchor: marker,
                        map: this.map,
                    });
                });
                data.marker = marker;
            } catch (error) {
                console.error(`Erro ao criar marker para ponto ${index}:`, error);
                const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
                this.snackBar.open(`Erro ao criar marker: ${errorMessage}`, '⚠️', { 
                    panelClass: 'warning',
                    duration: 3000 
                });
                // Continua com os próximos pontos
            }
        });

        if (this.dataPositions.length > 0) {
            this.dataInicioGPS = this.dataPositions[0].data_transmissao;
            this.dataFimGPS = this.dataPositions[this.dataPositions.length - 1].data_transmissao;
        }

        this.toggleStopPoint({ checked: true });
        this.toggleDirections({ checked: true });
    }

    private stringToLatLng(string: string) {
        if (!(window as any).google) {
            throw new Error('Google Maps não está carregado');
        }

        // Validação robusta da string de geolocalização
        if (!string || typeof string !== 'string' || string.trim() === '') {
            console.warn('Geolocalização inválida (vazia ou não é string):', string);
            throw new Error('Coordenada de geolocalização vazia ou inválida');
        }

        const geoSplited = string.split(',');
        
        // Verifica se tem exatamente 2 partes (lat, lng)
        if (geoSplited.length !== 2) {
            console.warn('Formato de geolocalização inválido (deve ser lat,lng):', string);
            throw new Error(`Formato de coordenada inválido: ${string}`);
        }

        const lat = Number(geoSplited[0].trim());
        const lng = Number(geoSplited[1].trim());

        // Verifica se os valores são números válidos
        if (isNaN(lat) || isNaN(lng)) {
            console.warn('Coordenadas não são números válidos:', { lat: geoSplited[0], lng: geoSplited[1], original: string });
            throw new Error(`Coordenadas não numéricas: lat=${geoSplited[0]}, lng=${geoSplited[1]}`);
        }

        // Verifica se as coordenadas estão em faixas válidas
        if (lat < -90 || lat > 90) {
            console.warn('Latitude fora da faixa válida (-90 a 90):', lat);
            throw new Error(`Latitude inválida: ${lat} (deve estar entre -90 e 90)`);
        }

        if (lng < -180 || lng > 180) {
            console.warn('Longitude fora da faixa válida (-180 a 180):', lng);
            throw new Error(`Longitude inválida: ${lng} (deve estar entre -180 e 180)`);
        }

        return new (window as any).google.maps.LatLng(lat, lng);
    }

    private getInfoWindowContent(dataPosition: any) {
        if (!this.infoWindow || !(window as any).google) return '';
        
        // open
        this.infoWindowEvent.open = (window as any).google.maps.event.addListener(this.infoWindow, 'domready', () => {
            const btnAdd = document.getElementById(`${dataPosition._id}_add`);
            btnAdd && btnAdd.addEventListener('click', () => {
                this.selectInfo2Points(dataPosition);
                this.infoWindow?.close();
                this.removeInfoWindowListener();
            });

            const btnRemove = document.getElementById(`${dataPosition._id}_remove`);
            btnRemove && btnRemove.addEventListener('click', () => {
                this.removeInfo2Points(dataPosition);
                this.infoWindow?.close();
                this.removeInfoWindowListener()
            });
        });

        // close
        this.infoWindowEvent.close = (window as any).google.maps.event.addListener(this.infoWindow, 'closeclick', () => this.removeInfoWindowListener());

        return dataPosition.start ? `
            <div class="overflow-hidden" style="width: 15rem">
                <div class="row">
                    <div class="col-6 mb-3">
                        <span class="fs-5">${dataPosition.qtde}</span>
                        <div class="fw-lighter text-gray">Qtde de pontos</div>
                    </div>
                    <div class="col-6 mb-3">
                        <span class="fs-5">${formatHumanTime(dataPosition.period, true, 'seconds')}</span>
                        <div class="fw-lighter text-gray">Duração</div>
                    </div>
                    <div class="col-6">
                        <span class="fs-5">${this.datePipe.transform(dataPosition.start, 'HH:mm:ss')}</span>
                        <div class="fw-lighter text-gray">Inicio da parada</div>
                    </div>
                    <div class="col-6">
                        <span class="fs-5">${this.datePipe.transform(dataPosition.end, 'HH:mm:ss')}</span>
                        <div class="fw-lighter text-gray">Fim da parada</div>
                    </div>
                </div>
            </div>
        ` : `
            <div class="overflow-hidden">
                <span class="status-badge bg-${dataPosition.ignicao ? 'danger' : 'success'} text-white mb-1">${dataPosition.ignicao ? 'Desligado' : 'Ligado'}</span>
                <div class="dotted-line fs-7 mt-1">
                    <div class="d-flex justify-content-between mt-1">
                        <span class="fw-lighter me-1">Data/Hora</span>
                        <span>${this.datePipe.transform(dataPosition.data_transmissao, 'dd/MM/yyyy HH:mm:ss')}</span>
                    </div>
                    <div class="d-flex justify-content-between mt-1">
                        <span class="fw-lighter me-1">Bateria</span>
                        <span>${dataPosition.bateria}</span>
                    </div>
                    <div class="d-flex justify-content-between mt-1">
                        <span class="fw-lighter me-1">Velocidade</span>
                        <span>${dataPosition.velocidade}km/h</span>
                    </div>
                    <div class="d-flex justify-content-between mt-1">
                        <span class="fw-lighter me-1">Odometro</span>
                        <span>${dataPosition.odometro} km</span>
                    </div>
                    <div class="d-flex justify-content-between mt-1">
                        <span class="fw-lighter me-1">Horímetro</span>
                        <span>${dataPosition.horimetro}</span>
                    </div>
                </div>
                ${this.points.info2Points.start !== dataPosition.odometro && this.points.info2Points.end !== dataPosition.odometro ? `
                    <button class="mat-mdc-unelevated-button mdc-button mat-primary btn-sm w-100 mt-2" id="${dataPosition._id}_add">
                        ${!this.points.info2Points.start ? 'Selecionar Partida' : 'Selecionar Destino'}
                    </button>
                ` : this.points.info2Points.start == dataPosition.odometro || this.points.info2Points.end == dataPosition.odometro ? `
                    <button class="mat-mdc-unelevated-button mdc-button mat-warn btn-sm w-100 mt-2" id="${dataPosition._id}_remove">
                        Desmarcar Ponto
                    </button>
                ` : ''}
            </div>`
    }

    private selectInfo2Points(dataPosition: any) {
        this.points.info2Points.end = this.points.info2Points.start && this.points.info2Points.end === null ? dataPosition.data_transmissao : this.points.info2Points.end;
        this.points.info2Points.start = this.points.info2Points.start === null ? dataPosition.data_transmissao : this.points.info2Points.start;
        this.points.info2Points.start && this.points.info2Points.end && this.getInfos2Points()
    }

    private removeInfo2Points(dataPosition: any) {
        dataPosition.marker?.setAnimation(null);
        this.removePartialDirection()
        this.show.info2Points = false;
        this.points.info2Points.start = this.points.info2Points.start === dataPosition.data_transmissao ? null : this.points.info2Points.start;
        this.points.info2Points.end = this.points.info2Points.end === dataPosition.data_transmissao ? null : this.points.info2Points.end;
    }

    private getInfos2Points() {
        this.show.info2Points = true;
        this.loading.info2Points = true;

        this.metricaService.getMetrics(this.dio.alocacao.equipamento.placa, this.points.info2Points.start!, this.points.info2Points.end!).subscribe({
            next: (res) => {
                this.points.info2Points.data = res;

                this.points.info2Points.data.disponibilidadeTotalMinutes = formatarTempoMinutosESegundos(this.points.info2Points.data.disponibilidadeTotalMinutes);
                this.points.info2Points.data.funcionamentoTotalMinutes = formatarTempoMinutosESegundos(this.points.info2Points.data.funcionamentoTotalMinutes);

                const startIndex = this.dataPositions.findIndex((point) => point.odometro === this.points.info2Points.start);
                const endIndex = this.dataPositions.findIndex((point) => point.odometro === this.points.info2Points.end);
                
                startIndex < endIndex 
                    ? this.toggleDirections({ checked: true }, this.dataPositions.slice(startIndex, endIndex + 1)) 
                    : this.toggleDirections({ checked: true }, this.dataPositions.slice(endIndex, startIndex + 1))
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.info2Points = false);
    }

    closeInfos2Points() {
        this.show.info2Points = false;
        this.points.info2Points.start = null;
        this.points.info2Points.end = null;
        this.removePartialDirection()
    }

    private removeInfoWindowListener() {
        google.maps.event.removeListener(this.infoWindowEvent.open);
        google.maps.event.removeListener(this.infoWindowEvent.close);
    }

    private removePartialDirection() {
        this.toggleDirections({ checked: true });
        this.currentDirectionPaths = [];
    }

    public isModoAtestoFuncionario() {       
        const podeAtestarDio = [
            RolesEnum.FUNCIONARIO.toString(), 
            RolesEnum.GESTAO_ADMIN.toString()
        ]; 

        return podeAtestarDio.includes(this.currentRole) && this.dio.statusExecucao === StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO;
    }

    public isModoValidacaoFiscal() {
        const podeValidarDio = [
            RolesEnum.FISCAL.toString(),
            RolesEnum.GESTAO_ADMIN.toString()
        ];

        const statusValidacao = [
            StatusExecucaoDIO.AGUARDANDO_FISCAL.toString(),    
        ];

        return podeValidarDio.includes(this.currentRole) && statusValidacao.includes(this.dio.statusExecucao!);
    }

    public responseCancelarApontamento(apontamento: any) {
        
    }

    openToSignDialog() {
        this.dialog.open(AssinaturaDioComponent, {
            data: {
                dioId: this.dio.id,
                dioNumber: this.dio.numero,
                statusExecucao: this.dio.statusExecucao
            }, width: '500px'
        })
    }

    changeSideBar() {
        this.sharedService.updateHideSideBarValue();
    }
}
